const ConfiguredStatusBar = () => {
	return null;
};
export default ConfiguredStatusBar;
